import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "inst-title" }, "갇힌 공간 검사", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("pre", { class: "inst-desc" }, "모델에 갇힌 공간이 존재할 경우,\n      · 공구가 들어가지 않아 가공할 수 없거나\n      · 제조하고 남은 재료들을 제거하지 못할 수 있습니다.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "inst-subtitle" }, "[해결방법]", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("pre", { class: "inst-desc" }, "초기 설계 단계에서 여러 파트로 구성 한 뒤 조립", -1)
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_5))
}